import script from "./LearningOutcomesDetails.vue?vue&type=script&setup=true&lang=js"
export * from "./LearningOutcomesDetails.vue?vue&type=script&setup=true&lang=js"

import "./LearningOutcomesDetails.vue?vue&type=style&index=0&id=715c805e&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/ignis-front-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-715c805e"]])

export default __exports__